import p1 from '../assest/p1.jpg'
import p2 from '../assest/p2.jpeg'
const Data=[
    {
        img: "https://cdn.decoist.com/wp-content/uploads/2015/11/Ladder-bookshelves-and-bold-pendants-for-the-modern-library.jpg",
        title: "Library Management System",
        text: "The Library Management System is a web app built with React and Firebase. It allows users to manage books, view details and availability, and track borrowing history. It includes authentication, search, and Firebase integration for seamless management.",
        view: "https://smartlibrarysystem.vercel.app/",
        source: "https://github.com/dnikunj178/RFID-Based-Library-Management-System",
    },
    {
        img: "https://www.shutterstock.com/image-photo/do-list-notebook-coffee-cup-260nw-1137115346.jpg",
        title: "Todo app",
        text: "I developed a Todo Web App using React, Node.js, and MongoDB. It features an intuitive interface, seamless cross-device experience, and efficient task management. This project highlights my skills in UI design, database management, and backend development.",
        view: "https://todo-phi-steel.vercel.app/",
        source: "https://github.com/Tejas7102/todolist",
    },
    {
        img: "https://img.lovepik.com/photo/40027/7318.jpg_wh300.jpg",
        title: "Ecommerce Website",
        text: "The E-commerce website is built with HTML, CSS, and PHP. It offers user-friendly shopping with attractive designs and essential features like product browsing and cart management. HTML provides structure, CSS handles styling, and PHP manages server-side functions for a seamless experience.",
        view: "",
        source: "https://github.com/Tejas7102/favourite-tailor-website",
    },
    {
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzCRDxo1n9xTHBm5OljQIkxFlpp3bMgJIPxw&usqp=CAU",
        title: "Tic Tac Toe",
        text: "The multiplayer Tic Tac Toe game is built with Python, offering an interactive interface for multiple players. Python handles game logic, player turns, and win conditions. Enjoyable gaming experience for all.",
        view: "",
        source: "https://github.com/Tejas7102/tic-tac-toe",
    }

]

export default Data
